import { makeStyles } from "@material-ui/core";
import { RemittanceLinkedToInvoiceActivity } from "api/activity";
import { asCurrency, asDate, asTimelessDate, CollapsableSection, Column, Columns, FormInput, isEmbeddedApp, Link, PopoverValue } from "lqx-react";
import * as React from "react";
import { RemittanceDocumentLink } from "./remittanceDocumentLink";

export const RemittanceLinkedToInvoiceDetails = ({data, currency} : {
    data : RemittanceLinkedToInvoiceActivity,
    currency : string
}) => {
    const classes = useTextStyles();

    return (
        <>
        <CollapsableSection title="Remittance Details:">
            <Columns>
                <Column>
                    <FormInput label="Remittance Amount" value={asCurrency(data.remittanceDetails.amount, currency)} />
                    <FormInput label="Value Date" value={asTimelessDate(data.remittanceDetails.valueDate)} />
                </Column>
                <Column>
                    <FormInput label="Statement Date" value={asTimelessDate(data.remittanceDetails.statementDate)} />
                    <RemittanceDocumentLink remittanceDocument={data.remittanceDetails.remittanceDocument} />
                </Column>
            </Columns>
        </CollapsableSection>
        <CollapsableSection title="Invoice(s) Linked">
            <Columns>
                <Column>
                <label className={ classes.root }>
                    <span className={ classes.label }>
                        Number of Invoices
                    </span>
                    <div className={ classes.invoiceNumberValue }>
                        <PopoverValue anchorAlign="left" transformAlign="center" withCloseIcon={false} label={ data.invoices.length }>
                            {data.invoices.length ?
                            <>
                                {data.invoices.map(inv => 
                                    <div key={inv.cid}>
                                        <Link disabled={ isEmbeddedApp() } href={`/invoices/details/${inv.invoiceId}`}>
                                            {inv.invoiceNumber}
                                        </Link>
                                    </div>
                                )}
                            </> : undefined }
                        </PopoverValue>
                    </div>
                    </label>
                </Column>
            </Columns>
        </CollapsableSection>
        <CollapsableSection title="Customer Details:">
            <Columns>
                <Column>
                    <FormInput label="Customer Name" value={data.relationshipDetails.customerName} />
                </Column>
            </Columns>
        </CollapsableSection>
        <CollapsableSection title="Supplier Details:">
            <Columns>
                <Column>
                    <FormInput label="Legal Entity Name" value={data.relationshipDetails.supplierLegalEntityName} />
                </Column>
                <Column>
                    <FormInput label="Company Code" value={data.relationshipDetails.supplierCompanyCode} />
                </Column>   
            </Columns>
        </CollapsableSection>
        </>
    );
}

const useTextStyles = makeStyles({
    root : {
        display: 'flex',
        flexDirection: 'row',
        color: '#767D84',
        fontFamily: 'Montserrat',
        fontSize: 12,
        fontWeight: 500,

        '&:focus-within' : {
            color: '#1084D3',
            fontWeight: 600,
        }
    },

    label: {
        flex: 2,
        alignSelf: 'center',
    },

    invoiceNumberValue : {
        flexDirection: 'column',
        flex : 3,
        display: 'inline-flex',
    },
});